"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.knowledge.updated': 'Avatar knowledge base updated successfully',
    'avatar.knowledge.load.error': 'Failed to load avatar knowledge',
    'avatar.knowledge.update.error': 'Failed to update avatar knowledge',
};
